const initialStates = {
    show: false,
}

const mutations = {
    set(state, show) {
        state.show = show
    },
    toggleShow(state) {
        state.show = !state.show
    }
}

const getters = {
    show: state => state.show
}

const actions = {
    setShowLoading({commit}, show = true) {
        commit('set', show)
    },
    hideShowLoading({commit}) {
        commit('set', false)
    },
    toggleShowLoading({commit}) {
        commit('toggleShow')
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}